import type { App } from 'vue'
import { bugsnagService } from '@/config/bugsnag'

export function setupGlobalErrorHandling(app: App): void {
  // Vue global error handler
  app.config.errorHandler = (error: unknown, instance, info) => {
    console.error('[Vue Error]', error, info)
    
    const errorObj = error instanceof Error ? error : new Error(String(error))
    
    bugsnagService.notify(errorObj, {
      vue: {
        componentName: instance?.$options.name || 'Unknown',
        componentInfo: info,
        propsData: instance?.$props,
        timestamp: new Date().toISOString()
      }
    })
  }

  // Global unhandled promise rejection handler
  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Promise Rejection]', event.reason)
    
    const error = event.reason instanceof Error 
      ? event.reason 
      : new Error(`Unhandled Promise Rejection: ${String(event.reason)}`)
    
    bugsnagService.notify(error, {
      promiseRejection: {
        reason: String(event.reason),
        timestamp: new Date().toISOString(),
        stack: error.stack
      }
    })
  })

  // Global JavaScript error handler (fallback)
  window.addEventListener('error', (event) => {
    console.error('[Global JavaScript Error]', event.error)
    
    const error = event.error instanceof Error 
      ? event.error 
      : new Error(event.message)
    
    bugsnagService.notify(error, {
      globalError: {
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        message: event.message,
        timestamp: new Date().toISOString()
      }
    })
  })
}
